import { render, staticRenderFns } from "./studentAnswers.vue?vue&type=template&id=f5eff1d4&"
import script from "./studentAnswers.vue?vue&type=script&lang=js&"
export * from "./studentAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports